module.exports = __webpack_public_path__ + "img/iphonexsmax_splash.0bd6c234.png";